/**
 * mobile-accordion.js
 * Smooth accordion for mobile nav.
 * Add to assets/ and include before </body>:
 *   <script src="{{ 'navigation-accordion-fix.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  function isMobile() { return window.innerWidth < 1025; }

  function injectStyles() {
    if (document.getElementById('mob-accordion-css')) return;
    const s = document.createElement('style');
    s.id = 'mob-accordion-css';
    s.textContent = `
      @media (max-width: 1024px) {

        .navigation .level0 > .submenu {
          position: static !important;
          visibility: visible !important;
          opacity: 1 !important;
          transform: none !important;
          box-shadow: none !important;
          border: none !important;
          background: transparent !important;
          padding: 0 !important;
          margin: 0 !important;
          width: 100% !important;
          overflow: hidden !important;
          /* height is driven by JS — no max-height trick */
          pointer-events: none;
        }

        .navigation .level0.mob-open > .submenu {
          pointer-events: auto;
        }

        .navigation .level0 > .submenu > div.hidden-1025 {
          display: none !important;
        }

        .navigation .level0 > .submenu .menu-list,
        .navigation .level0 > .submenu ul {
          padding-left: 16px !important;
        }

        .navigation open-children-toggle .icon-down.block:not(.hidden-1025),
        .navigation open-children-toggle svg[class*="hidden-1025"] {
          display: none !important;
        }

        .mob-chevron {
          display: inline-flex !important;
          align-items: center;
          justify-content: center;
          width: 44px;
          height: 44px;
          flex-shrink: 0;
          transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
          pointer-events: none;
        }
        .mob-chevron svg { display: block; }

        .navigation .level0.mob-open .mob-chevron {
          transform: rotate(180deg);
        }

        .navigation open-children-toggle {
          position: relative !important;
          z-index: 2;
          cursor: pointer;
          min-width: 44px;
          min-height: 44px;
          display: inline-flex !important;
          align-items: center;
          justify-content: center;
        }
      }
    `;
    document.head.appendChild(s);
  }

  const CHEVRON_HTML = `
    <span class="mob-chevron hidden-1025" aria-hidden="true">
      <svg width="18" height="18" fill="none" viewBox="0 0 24 24"
           stroke="currentColor" stroke-width="2.2"
           stroke-linecap="round" stroke-linejoin="round">
        <path d="M6 9l6 6 6-6"/>
      </svg>
    </span>`;

  /* ── Smooth open: measure real height then animate to it ── */
  function openSubmenu(submenu) {
    // Measure natural height
    submenu.style.transition = 'none';
    submenu.style.height = 'auto';
    const fullH = submenu.scrollHeight;
    submenu.style.height = '0px';
    submenu.offsetHeight; // force reflow
    // Animate
    submenu.style.transition = 'height 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
    submenu.style.height = fullH + 'px';
    // After done, set auto so content can grow/shrink freely
    submenu.addEventListener('transitionend', function done() {
      submenu.removeEventListener('transitionend', done);
      submenu.style.height = 'auto';
    }, { once: true });
  }

  /* ── Smooth close: pin current height then animate to 0 ── */
  function closeSubmenu(submenu) {
    submenu.style.transition = 'none';
    submenu.style.height = submenu.scrollHeight + 'px';
    submenu.offsetHeight; // force reflow
    submenu.style.transition = 'height 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
    submenu.style.height = '0px';
  }

  function wireItem(li) {
    if (li.dataset.mobAccordion) return;
    li.dataset.mobAccordion = '1';

    const submenu = li.querySelector(':scope > .submenu');
    const toggle  = li.querySelector(':scope > menu-item open-children-toggle');
    if (!submenu || !toggle) return;

    // Set initial closed height explicitly so transitions work from the start
    submenu.style.height = '0px';

    if (!toggle.querySelector('.mob-chevron')) {
      toggle.insertAdjacentHTML('beforeend', CHEVRON_HTML);
    }

    toggle.addEventListener('click', function handler(e) {
      if (!isMobile()) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      const isOpen = li.classList.contains('mob-open');

      // Close all open siblings smoothly
      if (li.parentElement) {
        li.parentElement.querySelectorAll(':scope > .level0.mob-open').forEach(function (sib) {
          if (sib === li) return;
          sib.classList.remove('mob-open');
          const sibSub = sib.querySelector(':scope > .submenu');
          if (sibSub) closeSubmenu(sibSub);
        });
      }

      if (isOpen) {
        li.classList.remove('mob-open');
        closeSubmenu(submenu);
      } else {
        li.classList.add('mob-open');
        openSubmenu(submenu);
      }
    }, true);
  }

  function init() {
    if (!isMobile()) return;
    injectStyles();
    document.querySelectorAll(
      '.navigation .level0.menu-parent, .navigation .level0.dropdown-menu'
    ).forEach(wireItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('DOMContentLoaded', function () {
    const nav = document.querySelector('.navigation');
    if (!nav) return;
    new MutationObserver(function (mutations) {
      if (!isMobile()) return;
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          setTimeout(init, 50);
        }
      });
    }).observe(nav, { attributes: true });
  });

  let lastMobile = isMobile();
  window.addEventListener('resize', function () {
    const nowMobile = isMobile();
    if (nowMobile && !lastMobile) init();
    lastMobile = nowMobile;
  });
})();
